import { render, staticRenderFns } from "./NavBarSustainability.vue?vue&type=template&id=973441fe"
import script from "./NavBarSustainability.vue?vue&type=script&lang=js"
export * from "./NavBarSustainability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports